import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bus from "../../common/bus";
import Tools from "../../common/Tools.js";
import api from "../../../api/api.js";
import apiAllSystem from "../../../api/apiAllSystem.js";
export default {
  name: 'taskManage',
  components: {// 注册    
  },
  data: function data() {
    return {
      pagesize: 10,
      //每页显示条数
      curPage: 1,
      //当前页数
      query: {
        input: '',
        company: '',
        createTime: ''
      },
      companySelect: [],
      groupSelect: [],
      tableData: [],
      multipleSelection: [],
      permissions: {},
      loading: false,
      totalNum: 0
    };
  },
  created: function created() {
    this.permissions = this.global.permissions.groupManage;
    this.getCompany();
    this.getData();
  },
  computed: {
    columns: function columns() {
      return [{
        title: this.$t('GroupManage.groupName'),
        key: 'trackergroupname'
      }, {
        title: this.$t('GroupManage.company'),
        key: 'fathernickname'
      }, {
        title: this.$t('GroupManage.createTime'),
        key: 'registertime'
      }];
    }
  },
  watch: {
    '$route': function $route(to, from) {
      //监听到路由（参数）改变
      // 拿到目标参数 to.query.state 去再次请求数据接口
      if (to.path == "/groupManage") {
        this.getCompany();
        this.getData();
      }
    }
  },
  methods: {
    getCompany: function getCompany() {
      var _this = this;

      var params = {
        usersssid: localStorage.getItem('sssid')
      };
      api.getUser(params).then(function (res) {
        if (res.state) {
          _this.companySelect = res.value;
        } else {
          _this.$message.error(res.value.text);
        }
      });
    },
    getData: function getData() {
      var _this2 = this;

      this.loading = true;
      var params = {
        usersssid: localStorage.getItem('sssid'),
        groupname: this.query.input,
        beginregistertime: this.query.createTime[0],
        endregistertime: this.query.createTime[1],
        offset: (this.curPage - 1) * this.pagesize,
        limit: this.pagesize
      };

      if (this.query.company !== '') {
        params.usersssid = this.query.company;
      }

      if (this.$route.query.detail) {
        params.orderfirstsssid = this.$route.query.detail;
      }

      api.getTrackerGroup(params).then(function (res) {
        _this2.loading = false;

        if (res.state) {
          _this2.permissions = _this2.global.permissions.groupManage;
          _this2.totalNum = parseInt(res.message);
          _this2.tableData = res.value;
        } else {
          _this2.$message.error(res.value.text);
        }
      }).catch(function (error) {
        _this2.$message.error(_this2.$t('Message.reqError'));
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.curPage = 1;
      this.getData();
    },
    //重置
    handleClean: function handleClean() {
      this.query.input = "";
      this.query.company = "";
      this.query.createTime = "";
      this.getData();
    },
    // 新建
    handleCreate: function handleCreate() {
      this.$router.push({
        path: '/groupCreate'
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      // 二次确认删除
      this.$confirm(this.$t('Message.confirmDelete'), this.$t('Message.tip'), {
        type: 'warning'
      }).then(function () {
        var params = {
          usersssid: row.fatherusersssid,
          delsssid: row.sssid
        };
        api.deleteTrackerGroup(params).then(function (res) {
          if (res.state) {
            _this3.$message.success(_this3.$t('Message.delete'));

            _this3.getData();
          } else {
            _this3.$message.error(res.value.text);
          }
        }).catch(function (error) {
          _this3.$message.error(_this3.$t('Message.reqError'));
        });
      }).catch(function () {});
    },
    // 多选操作
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 多选删除
    delAllSelection: function delAllSelection() {
      var _this4 = this;

      if (this.multipleSelection.length < 1) {
        this.$message.warning(this.$t('Message.selectDeleteItem'));
        return;
      } // 二次确认删除


      this.$confirm(this.$t('Message.confirmDelete'), this.$t('Message.tip'), {
        type: 'warning'
      }).then(function () {
        var successcount = 0;
        var failinfo = "";

        _this4.multipleSelection.forEach(function (item) {
          var params = {
            usersssid: item.fatherusersssid,
            delsssid: item.sssid
          };
          api.deleteTrackerGroup(params).then(function (res) {
            if (res.state) {
              successcount++;
            } else {
              if (failinfo == "") {
                failinfo += item.trackergroupname;
              } else {
                failinfo += "," + item.trackergroupname;
              }
            }
          }).catch(function (error) {
            if (failinfo == "") {
              failinfo += item.trackergroupname;
            } else {
              failinfo += "," + item.trackergroupname;
            }
          });
        });

        setTimeout(function () {
          if (failinfo == "") {
            _this4.$message.success(_this4.$t('Message.delete'));

            _this4.getData();
          } else {
            _this4.$message.error(failinfo + _this4.$t('Message.deleteFail'));
          }
        }, 1000);
      }).catch(function () {});
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.$router.push({
        path: '/groupEdit',
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    //点击进入详情页
    handleDetail: function handleDetail(detail) {// this.$router.push({path:'/', query:{id:detail.id}});
    },
    //当前显示条数
    handleCurentChange: function handleCurentChange(val) {
      this.curPage = val;
      this.getData();
    },
    //设置每页显示条数                 
    handleSizeChange: function handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    //导出
    // getExport(){           
    //     let id = localStorage.getItem('sssid');
    //     if(this.query.company) {
    //         id = this.query.company;
    //     }
    //     let key = "";
    //     if(this.query.input !== "") {
    //         key = '&key=' + this.query.input;
    //     }
    //     let time = "";
    //     if(this.query.createTime){
    //         time = '&beginregistertime=' + this.query.createTime[0] + '&endregistertime=' + this.query.createTime[1];
    //     }
    //     return this.GLOBAL.serverSrc + 'TrackerGroup/DownloadExcel?filename=data&usersssid='+id+key+time;
    // },        
    //导出
    handleExport: function handleExport() {
      var id = localStorage.getItem('sssid');

      if (this.query.company) {
        id = this.query.company;
      }

      var key = "";

      if (this.query.input !== "") {
        key = '&key=' + this.query.input;
      }

      var time = "";

      if (this.query.createTime) {
        time = '&beginregistertime=' + this.query.createTime[0] + '&endregistertime=' + this.query.createTime[1];
      }

      var url = this.GLOBAL.serverSrc + 'TrackerGroup/DownloadExcel?filename=data&usersssid=' + id + key + time;
      api.download(this, url, this.$t('Export.group'));
    },
    //移动
    handleMove: function handleMove() {
      this.$router.push({
        path: '/groupMove'
      });
    }
  }
};